import { atom, SetterOrUpdater, useRecoilState } from "recoil"
import { RECOIL_KEY } from "globalState/key"
import { ArticleWithPhoto } from "type"

const displayedArticleAtom = atom<ArticleWithPhoto>({
  key: RECOIL_KEY.DISPLAYED_ARTICLE,
  default: undefined
})

export const useDisplayedArticle = (): [ArticleWithPhoto, SetterOrUpdater<ArticleWithPhoto>]=>{
  return useRecoilState(displayedArticleAtom)
}